export default __webpack_public_path__ + "maps-examples-data-driven-symbols-960-ee89b0d07353c057915aa4d96faa5b36.png";